import * as React from 'react';
import { Flex, TextOrNode, Spinner } from "./..";
export var Loading = function (_a) {
    var _b = _a.spinnerSize, spinnerSize = _b === void 0 ? 'lg' : _b, message = _a.message, _c = _a.title, title = _c === void 0 ? '' : _c;
    return (React.createElement(Flex, { lss: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            m: 'auto'
        } },
        React.createElement(Spinner, { title: title, size: spinnerSize, lss: { mb: 'sm' } }),
        React.createElement(TextOrNode, null, message)));
};
//# sourceMappingURL=Loading.js.map